import {
  bool,
  func,
  instanceOf,
  number,
  objectOf,
  oneOfType,
  shape,
  string,
} from 'prop-types';

const buildingsForFilterTypes = objectOf(
  shape({
    id: number.isRequired,
    name: string.isRequired,
    parent: shape({
      id: number.isRequired,
    }).isRequired,
    externalServiceRequest: bool,
  }),
);

const refTypes = oneOfType([
  func,
  shape({ current: instanceOf(Element) }),
  shape({ current: instanceOf(Object) }),
]);

export { buildingsForFilterTypes, refTypes };
